import Snif from './snif';

const fallbacks = {
    mixins: [Snif],
    data() {
        return { fallbacksInitiated: false };
    },
    methods: {
        initFallbacks: function objectFitFallback() {
            const html = document.documentElement;

            if (this.isIOS()) html.classList.add('is-ios');

            if (this.isSafari()) html.classList.add('is-safari');

            if (this.isFF()) html.classList.add('is-ff');

            if (this.isChromeAndroid()) html.classList.add('is-ca');

            if (this.isMS()) {
                html.classList.add('is-ms');
            }

            if (this.isIe11()) html.classList.add('is-ie');

            this.fallbacksInitiated = true;
        }
    }
};

export default fallbacks;
